import { Button, Tabs, Form, Typography } from "antd";

import React, { createRef, useEffect, useState } from "react";
import "../../styles/components.scss";
import { HeaderUser } from "../../components/HeaderUser";
import { FormattedMessage } from "react-intl";
import { useLocation, useNavigate } from "react-router-dom";
import { getListTemplatesUser, toAddAssessment } from "../../utils/APIs";
import { PracticeProfile } from "../../components/PracticeProfile";
import ManageTheDataUser from "../Admin/ManageTheDataUser";
import { useIndexedDBStore } from "use-indexeddb";
import ScreenLoader from "../../components/ScreenLoader";

const { TabPane } = Tabs;

const Tool = () => {
  const navigate = useNavigate();

  const { getByID, add } = useIndexedDBStore("assessments");
  const location = useLocation();
  const [id, setId] = useState(null != location.state ? location.state.id : -1);

  const [nb, setNB] = useState(Math.floor(Math.random() * 100));
  const [elRefs, setElRefs] = React.useState([]);
  const [form] = Form.useForm();
  const [step, setStep] = useState(1);
  const [separateTeensAdults, setSeparateTeensAdults] = useState(false);
  const [showHourly, setShowHourly] = useState(false);
  const [loading, setLoading] = useState(true);
  const [separateRole, setSeparateRole] = useState(false);
  const [activeKey, setActive] = useState(0);
  const [targetKey, setTargetKey] = useState(-1);
  const [selectedItem, setSelectedItem] = useState(-1);
  const [emptyFields, setEmptyFields] = useState(false);
  const [templates, setTemplates] = useState([]);
  const [formPractice] = Form.useForm();
  const [formCases] = Form.useForm();

  useEffect(() => {
    var initialPanes = [];
    var templateId = -1;
    var data = null;
    if (id != -1) {
      getByID(id).then((res) => {
        templateId = res.templateId;
        data = res.results;
        setStep(3);
      });
    }

    getListTemplatesUser().then((res) => {
      res.forEach((element) => {
        element.practiceProfile = element.data.filter(
          (a) => a.fieldName == "practiceProfile"
        );
        initialPanes.push({
          title: element.name,
          content: element.name,
          indicators: element.indicators,
          key: element.id,
          visible: false,
          inputs: element.inputs,
          separateTeensAdults: element.practiceProfile[0].value.filter(
            (a) => a.fieldName == "separateTeensAdults"
          )[0]
            ? element.practiceProfile[0].value.filter(
                (a) => a.fieldName == "separateTeensAdults"
              )[0].value
            : false,

          data:
            templateId != -1 && templateId == element.id ? data : element.data,
        });
      });
      if (initialPanes.length > 0) {
        var index = initialPanes.findIndex((e) => e.key == templateId);
        if (index == -1) {
          index = 0;
        }
        setSelectedItem(initialPanes[index]);

        setSeparateTeensAdults(
          initialPanes[index].data
            .filter((a) => a.fieldName == "practiceProfile")[0]
            .value.filter((b) => b.fieldName == "separateTeensAdults")[0].value
        );
        setShowHourly(
          initialPanes[index].data
            .filter((a) => a.fieldName == "practiceProfile")[0]
            .value.filter((b) => b.fieldName == "showHourly")[0].value
        );

        setSeparateRole(
          initialPanes[index].data
            .filter((a) => a.fieldName == "practiceProfile")[0]
            .value.filter((b) => b.fieldName == "separateRole")[0].value
        );
        toUpdateForms(initialPanes[index]);
        setTemplates(initialPanes);
        setElRefs((elRefs) =>
          Array(initialPanes.length)
            .fill()
            .map((_, i) => elRefs[i] || createRef())
        );
        setActive(initialPanes[index].id);
      }
      setTimeout(() => {
        setLoading(false);
      }, 500);
    });
  }, []);

  const OnChange = (activeKey) => {
    setSeparateTeensAdults(
      templates
        .find((i) => i.key == activeKey)
        .data.filter((a) => a.fieldName == "practiceProfile")[0]
        .value.filter((b) => b.fieldName == "separateTeensAdults")[0].value
    );
    setShowHourly(
      templates
        .find((i) => i.key == activeKey)
        .data.filter((a) => a.fieldName == "practiceProfile")[0]
        .value.filter((b) => b.fieldName == "showHourly")[0].value
    );
    //todo add separate role
    setSelectedItem(templates.find((i) => i.key == activeKey));
    //setChildRef(createRef());
    setActive(activeKey);
  };

  const hidePopup = () => {
    var initialPanes = [...templates];
    if (targetKey != -1) {
      initialPanes.forEach((element) => {
        element.visible = false;
      });
      setTemplates(initialPanes);
      setTargetKey(-1);
    }
  };

  const toUpdateForms = (element) => {
    formPractice.setFieldsValue({
      openDays: element.openDays,
      speciality: element.speciality,
      separateTeensAdults: element.separateTeensAdults,
    });
    formCases.setFieldsValue({
      newAlignersTreatement: "500",
      addFeeAligners: "50",
      averagePrice: "50",
    });
  };

  const toUpdateDataPractice = (values) => {
    selectedItem.data.forEach((a) => {
      if (a.fieldName == "practiceProfile") {
        a.value = values[0].value;
      }
    });

    var separateTeensAdults = selectedItem.data
      .filter((a) => a.fieldName == "practiceProfile")[0]
      .value.filter((b) => b.fieldName == "separateTeensAdults")[0].value;

    var showHourly = selectedItem.data
      .filter((a) => a.fieldName == "practiceProfile")[0]
      .value.filter((b) => b.fieldName == "showHourly")[0].value;
    var separateRole = selectedItem.data
      .filter((a) => a.fieldName == "practiceProfile")[0]
      .value.filter((b) => b.fieldName == "separateRole")[0].value;

    toChangeDisplay(
      selectedItem,
      separateRole,
      separateTeensAdults,
      showHourly
    );
  };

  const toChangeDisplay = async (
    selected,
    separateRole,
    separateTeensAdults,
    showHourly
  ) => {
    showHourly = "" + showHourly;
    separateTeensAdults = "" + separateTeensAdults;
    separateRole = "" + separateRole;
    //Show Staff & Doctor's hourly cost?

    selected.data
      .filter((a) => a.fieldName == "numberOfCases")[0]
      .value.filter((b) => b.fieldName == "cost")[0]
      .value.filter((c) => c.fieldName == "stafCostHour")[0].display =
      showHourly == "true" || showHourly == true ? true : false;

    selected.data
      .filter((a) => a.fieldName == "numberOfCases")[0]
      .value.filter((b) => b.fieldName == "cost")[0]
      .value.filter((c) => c.fieldName == "doctorCostHour")[0].display =
      showHourly == "true" || showHourly == true ? true : false;

    //Separate Staff by role?
    selected.data
      .filter((a) => a.fieldName == "timeSpentOnTheExam")[0]
      .value.filter((b) => b.fieldName == "staffTimeSpent")[0]
      .value.filter((c) =>
        (c.fieldName == separateRole) == "true" ? "average" : "dentalAssistant"
      )[0].fieldName = separateRole == "true" ? "dentalAssistant" : "average";

    selected.data
      .filter((a) => a.fieldName == "timeSpentOnTheExam")[0]
      .value.filter((b) => b.fieldName == "staffTimeSpent")[0]
      .value.filter((c) => c.fieldName == "treatmentCoordinator")[0].display =
      separateRole == "true" ? true : false;

    selected.data
      .filter((a) => a.fieldName == "timeSpentOnTheExam")[0]
      .value.filter((b) => b.fieldName == "staffTimeSpent")[0]
      .value.filter((c) => c.fieldName == "frontDesk")[0].display =
      separateRole == "true" ? true : false;

    selected.data
      .filter((a) => a.fieldName == "numberOfCases")[0]
      .value.filter((b) => b.fieldName == "cost")[0]
      .value.filter(
        (c) => c.fieldName == "stafCostHour"
      )[0].value[0].fieldName =
      separateRole == "true" ? "average" : "dentalAssistant";

    if (
      null !=
      selected.data
        .filter((a) => a.fieldName == "numberOfCases")[0]
        .value.filter((b) => b.fieldName == "cost")[0]
        .value.filter((c) => c.fieldName == "stafCostHour")[0]
        .value.filter((c) => c.fieldName == "treatmentCoordinator")[0].display
    ) {
      selected.data
        .filter((a) => a.fieldName == "numberOfCases")[0]
        .value.filter((b) => b.fieldName == "cost")[0]
        .value.filter((c) => c.fieldName == "stafCostHour")[0]
        .value.filter((c) => c.fieldName == "treatmentCoordinator")[0].display =
        separateRole == "true" ? true : false;
    }

    if (
      null !=
      selected.data
        .filter((a) => a.fieldName == "numberOfCases")[0]
        .value.filter((b) => b.fieldName == "cost")[0]
        .value.filter((c) => c.fieldName == "stafCostHour")[0]
        .value.filter((c) => c.fieldName == "frontDesk")[0].display
    ) {
      selected.data
        .filter((a) => a.fieldName == "numberOfCases")[0]
        .value.filter((b) => b.fieldName == "cost")[0]
        .value.filter((c) => c.fieldName == "stafCostHour")[0]
        .value.filter((c) => c.fieldName == "frontDesk")[0].display =
        separateRole == "true" ? true : false;
    }

    selected.data
      .filter((a) => a.fieldName == "workflowTreatment")[0]
      .value.filter((b) => b.fieldName == "alignersTimeSpent")[0]
      .value.filter((c) => {
        if (separateRole == "true") {
          if (c.fieldName == "staffTimeSpents") {
            c.fieldName = "dentalAssistant";
          }
        } else {
          if (c.fieldName == "dentalAssistant") {
            c.fieldName = "staffTimeSpents";
          }
        }
      });

    if (
      null !=
      selected.data
        .filter((a) => a.fieldName == "workflowTreatment")[0]
        .value.filter((b) => b.fieldName == "alignersTimeSpent")[0]
        .value.filter((c) => c.fieldName == "treatmentCoordinator")[0].display
    ) {
      selected.data
        .filter((a) => a.fieldName == "workflowTreatment")[0]
        .value.filter((b) => b.fieldName == "alignersTimeSpent")[0]
        .value.filter((c) => c.fieldName == "treatmentCoordinator")[0].display =
        separateRole == "true" ? true : false;

      selected.data
        .filter((a) => a.fieldName == "workflowTreatment")[0]
        .value.filter((b) => b.fieldName == "alignersTimeSpent")[0]
        .value.filter((c) => c.fieldName == "treatmentCoordinator")[0]
        .value.filter((d) => d.fieldName == "checkupAppointement")[0].display =
        separateRole == "true" ? true : false;

      selected.data
        .filter((a) => a.fieldName == "workflowTreatment")[0]
        .value.filter((b) => b.fieldName == "alignersTimeSpent")[0]
        .value.filter((c) => c.fieldName == "treatmentCoordinator")[0]
        .value.filter((d) => d.fieldName == "prepareAppointment")[0].display =
        separateRole == "true" ? true : false;
    }

    if (
      null !=
      selected.data
        .filter((a) => a.fieldName == "workflowTreatment")[0]
        .value.filter((b) => b.fieldName == "alignersTimeSpent")[0]
        .value.filter((c) => c.fieldName == "frontDesk")[0].display
    ) {
      selected.data
        .filter((a) => a.fieldName == "workflowTreatment")[0]
        .value.filter((b) => b.fieldName == "alignersTimeSpent")[0]
        .value.filter((c) => c.fieldName == "frontDesk")[0].display =
        separateRole == "true" ? true : false;
      selected.data
        .filter((a) => a.fieldName == "workflowTreatment")[0]
        .value.filter((b) => b.fieldName == "alignersTimeSpent")[0]
        .value.filter((c) => c.fieldName == "frontDesk")[0]
        .value.filter((d) => d.fieldName == "checkupAppointement")[0].display =
        separateRole == "true" ? true : false;
      selected.data
        .filter((a) => a.fieldName == "workflowTreatment")[0]
        .value.filter((b) => b.fieldName == "alignersTimeSpent")[0]
        .value.filter((c) => c.fieldName == "frontDesk")[0]
        .value.filter((d) => d.fieldName == "takeAppointment")[0].display =
        separateRole == "true" ? true : false;
    }

    selected.data
      .filter((a) => a.fieldName == "workflowTreatment")[0]
      .value.filter((b) => b.fieldName == "bracesTimeSpent")[0]
      .value.filter((c) => {
        if (separateRole == "true") {
          if (c.fieldName == "staffTimeSpents") {
            c.fieldName = "dentalAssistant";
          }
        } else {
          if (c.fieldName == "dentalAssistant") {
            c.fieldName = "staffTimeSpents";
          }
        }
      });

    if (
      null !=
      selected.data
        .filter((a) => a.fieldName == "workflowTreatment")[0]
        .value.filter((b) => b.fieldName == "bracesTimeSpent")[0]
        .value.filter((c) => c.fieldName == "treatmentCoordinator")[0].display
    ) {
      selected.data
        .filter((a) => a.fieldName == "workflowTreatment")[0]
        .value.filter((b) => b.fieldName == "bracesTimeSpent")[0]
        .value.filter((c) => c.fieldName == "treatmentCoordinator")[0].display =
        separateRole == "true" ? true : false;

      selected.data
        .filter((a) => a.fieldName == "workflowTreatment")[0]
        .value.filter((b) => b.fieldName == "bracesTimeSpent")[0]
        .value.filter((c) => c.fieldName == "treatmentCoordinator")[0]
        .value.filter((d) => d.fieldName == "prepareAppointment")[0].display =
        separateRole == "true" ? true : false;

      selected.data
        .filter((a) => a.fieldName == "workflowTreatment")[0]
        .value.filter((b) => b.fieldName == "bracesTimeSpent")[0]
        .value.filter((c) => c.fieldName == "treatmentCoordinator")[0]
        .value.filter((d) => d.fieldName == "checkupAppointement")[0].display =
        separateRole == "true" ? true : false;
    }

    if (
      null !=
      selected.data
        .filter((a) => a.fieldName == "workflowTreatment")[0]
        .value.filter((b) => b.fieldName == "bracesTimeSpent")[0]
        .value.filter((c) => c.fieldName == "frontDesk")[0].display
    ) {
      selected.data
        .filter((a) => a.fieldName == "workflowTreatment")[0]
        .value.filter((b) => b.fieldName == "bracesTimeSpent")[0]
        .value.filter((c) => c.fieldName == "frontDesk")[0].display =
        separateRole == "true" ? true : false;

      selected.data
        .filter((a) => a.fieldName == "workflowTreatment")[0]
        .value.filter((b) => b.fieldName == "bracesTimeSpent")[0]
        .value.filter((c) => c.fieldName == "frontDesk")[0]
        .value.filter((d) => d.fieldName == "checkupAppointement")[0].display =
        separateRole == "true" ? true : false;

      selected.data
        .filter((a) => a.fieldName == "workflowTreatment")[0]
        .value.filter((b) => b.fieldName == "bracesTimeSpent")[0]
        .value.filter((c) => c.fieldName == "frontDesk")[0]
        .value.filter((d) => d.fieldName == "takeAppointment")[0].display =
        separateRole == "true" ? true : false;
    }

    // separate teens and adults
    selected.data.forEach((a) =>
      a.value.forEach((b) => {
        if (b.fieldName == "general") {
          b.value.forEach((c) => {
            if (Array.isArray(c.value)) {
              c.value.forEach((d) => {
                if (separateTeensAdults == "true") {
                  if (d.fieldName == "average") {
                    d.fieldName = "adults";
                  }
                  if (d.fieldName == "teens") {
                    d.display = true;
                  }
                } else {
                  if (d.fieldName == "adults") {
                    d.fieldName = "average";
                  }
                  if (d.fieldName == "teens") {
                    d.display = false;
                    d.value = 0;
                  }
                }
              });
            }
          });
        }
        if (
          b.fieldName == "alignersCases" ||
          b.fieldName == "bracesCases" ||
          b.fieldName == "alignersStatistics" ||
          b.fieldName == "bracesStatistics" ||
          b.fieldName == "relapse"
        ) {
          b.value.forEach((c) => {
            c.value.forEach((d) => {
              if (separateTeensAdults == "true") {
                if (d.fieldName == "average") {
                  d.fieldName = "adults";
                }
                if (d.fieldName == "teens") {
                  d.display = true;
                }
              } else {
                if (d.fieldName == "adults") {
                  d.fieldName = "average";
                }
                if (d.fieldName == "teens") {
                  d.display = false;
                  d.value = 0;
                }
              }
            });
          });
        }
      })
    );
    selected = await changeProducts(selected);
    selected = await changePerioThree(selected);
    setNB(Math.floor(Math.random() * 10));
    setSeparateTeensAdults(separateTeensAdults);
    setShowHourly(showHourly);
    setSeparateRole(separateRole);
    setSelectedItem(selected);
  };

  const changePerioThree = (selected) => {
    var w24 = 0;
    try {
      w24 = parseFloat(
        selected.data
          .filter((a) => a.fieldName == "numberOfCases")[0]
          .value.filter((b) => b.fieldName == "general")[0]
          .value.filter((c) => c.fieldName == "newAlignersTreatement")[0]
          .value.filter((d) => d.fieldName == "adults")[0].value
      );
    } catch (error) {
      w24 = parseFloat(
        selected.data
          .filter((a) => a.fieldName == "numberOfCases")[0]
          .value.filter((b) => b.fieldName == "general")[0]
          .value.filter((c) => c.fieldName == "newAlignersTreatement")[0]
          .value.filter((d) => d.fieldName == "average")[0].value
      );
    }

    var w25 = parseFloat(
      selected.data
        .filter((a) => a.fieldName == "numberOfCases")[0]
        .value.filter((b) => b.fieldName == "general")[0]
        .value.filter((c) => c.fieldName == "newAlignersTreatement")[0]
        .value.filter((d) => d.fieldName == "teens")[0].value
    );

    var w28 = 0;
    try {
      w28 = parseFloat(
        selected.data
          .filter((a) => a.fieldName == "numberOfCases")[0]
          .value.filter((b) => b.fieldName == "general")[0]
          .value.filter((c) => c.fieldName == "newBraces")[0]
          .value.filter((d) => d.fieldName == "adults")[0].value
      );
    } catch (error) {
      w28 = parseFloat(
        selected.data
          .filter((a) => a.fieldName == "numberOfCases")[0]
          .value.filter((b) => b.fieldName == "general")[0]
          .value.filter((c) => c.fieldName == "newBraces")[0]
          .value.filter((d) => d.fieldName == "average")[0].value
      );
    }
    var w29 = parseFloat(
      selected.data
        .filter((a) => a.fieldName == "numberOfCases")[0]
        .value.filter((b) => b.fieldName == "general")[0]
        .value.filter((c) => c.fieldName == "newBraces")[0]
        .value.filter((d) => d.fieldName == "teens")[0].value
    );
    //conditions w24 > 0
    var valueW24 = false;
    if (w24 > 0) {
      valueW24 = true;
    }
    selected.data.forEach((a) =>
      a.value.forEach((b) => {
        if (
          b.fieldName == "alignersCases" ||
          b.fieldName == "alignersStatistics"
        ) {
          b.value.forEach((c) => {
            c.value.forEach((d) => {
              if (d.fieldName == "adults" || d.fieldName == "average") {
                d.display = valueW24;
              }
            });
          });
        }
      })
    );
    //conditions w25 >0
    var valueW25 = false;

    if (w25 > 0) {
      valueW25 = true;
    }
    selected.data.forEach((a) =>
      a.value.forEach((b) => {
        if (
          b.fieldName == "alignersCases" ||
          b.fieldName == "alignersStatistics"
        ) {
          b.value.forEach((c) => {
            c.value.forEach((d) => {
              if (d.fieldName == "teens") {
                d.display = valueW25;
              }
            });
          });
        }
      })
    );

    //conditions w28 > 0
    var valueW28 = false;
    if (w28 > 0) {
      valueW28 = true;
    }
    selected.data.forEach((a) =>
      a.value.forEach((b) => {
        if (b.fieldName == "bracesCases" || b.fieldName == "bracesStatistics") {
          b.value.forEach((c) => {
            c.value.forEach((d) => {
              if (d.fieldName == "adults" || d.fieldName == "average") {
                d.display = valueW28;
              }
            });
          });
        }
      })
    );

    //conditions w29 >0
    var valueW29 = false;

    if (w29 > 0) {
      valueW29 = true;
    }
    selected.data.forEach((a) =>
      a.value.forEach((b) => {
        if (b.fieldName == "bracesCases" || b.fieldName == "bracesStatistics") {
          b.value.forEach((c) => {
            c.value.forEach((d) => {
              if (d.fieldName == "teens") {
                d.display = valueW29;
              }
            });
          });
        }
      })
    );

    //conditions w24 + w25 > 0
    var valueW24W25 = false;
    if (w24 + w25 > 0) {
      valueW24W25 = true;
    }
    selected.data.forEach((a) =>
      a.value.forEach((b) => {
        if (
          b.fieldName == "alignersCases" ||
          b.fieldName == "alignersStatistics" ||
          b.fieldName == "alignersTimeSpent" ||
          b.fieldName == "alignersCost"
        ) {
          b.display = valueW24W25;
          b.value.forEach((c) => (c.display = valueW24W25));
        }
      })
    );

    //conditions w28 + w29 > 0
    var valueW28W29 = false;
    if (w28 + w29 > 0) {
      valueW28W29 = true;
    }
    selected.data.forEach((a) =>
      a.value.forEach((b) => {
        if (
          b.fieldName == "bracesCases" ||
          b.fieldName == "bracesStatistics" ||
          b.fieldName == "bracesTimeSpent" ||
          b.fieldName == "bracesCost"
        ) {
          b.display = valueW28W29;
          b.value.forEach((c) => (c.display = valueW28W29));
        }
      })
    );
    return selected;
  };

  const changeProducts = async (selected) => {
    var products = selected.data
      .filter((a) => a.fieldName == "practiceProfile")[0]
      .value.filter((b) => b.fieldName == "products")[0].value;

    var monitoringAligners = products.filter(
      (e) => e.fieldName == "monitoringFor"
    )[0].value;
    var monitoringBraces = products.filter((e) => e.fieldName == "bracesFor")[0]
      .value;

    try {
      selected.data
        .filter((a) => a.fieldName == "numberOfCases")[0]
        .value.filter((b) => b.fieldName == "general")[0]
        .value.filter((c) => c.fieldName == "newAlignersTreatement")[0]
        .value.filter((d) => d.fieldName == "adults")[0].display =
        monitoringAligners;
    } catch (error) {
      selected.data
        .filter((a) => a.fieldName == "numberOfCases")[0]
        .value.filter((b) => b.fieldName == "general")[0]
        .value.filter((c) => c.fieldName == "newAlignersTreatement")[0]
        .value.filter((d) => d.fieldName == "average")[0].display =
        monitoringAligners;
    }

    selected.data
      .filter((a) => a.fieldName == "numberOfCases")[0]
      .value.filter((b) => b.fieldName == "general")[0]
      .value.filter((c) => c.fieldName == "newAlignersTreatement")[0]
      .value.filter((d) => d.fieldName == "teens")[0].display =
      monitoringAligners;
    selected.data
      .filter((a) => a.fieldName == "numberOfCases")[0]
      .value.filter((b) => b.fieldName == "general")[0]
      .value.filter((c) => c.fieldName == "newAlignersTreatement")[0].display =
      monitoringAligners;

    try {
      selected.data
        .filter((a) => a.fieldName == "numberOfCases")[0]
        .value.filter((b) => b.fieldName == "general")[0]
        .value.filter((c) => c.fieldName == "newBraces")[0]
        .value.filter((d) => d.fieldName == "adults")[0].display =
        monitoringBraces;
    } catch (error) {
      selected.data
        .filter((a) => a.fieldName == "numberOfCases")[0]
        .value.filter((b) => b.fieldName == "general")[0]
        .value.filter((c) => c.fieldName == "newBraces")[0]
        .value.filter((d) => d.fieldName == "average")[0].display =
        monitoringBraces;
    }

    selected.data
      .filter((a) => a.fieldName == "numberOfCases")[0]
      .value.filter((b) => b.fieldName == "general")[0]
      .value.filter((c) => c.fieldName == "newBraces")[0]
      .value.filter((d) => d.fieldName == "teens")[0].display =
      monitoringBraces;
    selected.data
      .filter((a) => a.fieldName == "numberOfCases")[0]
      .value.filter((b) => b.fieldName == "general")[0]
      .value.filter((c) => c.fieldName == "newBraces")[0].display =
      monitoringBraces;

    return selected;
  };

  const getField = (data, id, values) => {
    data.forEach((element) => {
      if (element.fieldName == id) {
        if (Array.isArray(element.value)) {
          element.value.forEach((sub) => {
            sub.value = values[sub.fieldName];
          });
        } else {
          element.value = values[id];
        }
      }
    });
    return data;
  };

  const toUpdateTheDefaultData = (id, parent, data, first) => {
    if (null != parent) {
      var l__data = selectedItem.data
        .filter((a) => a.fieldName == first)[0]
        .value.filter((b) => b.fieldName == parent);
      selectedItem.data
        .filter((a) => a.fieldName == first)[0]
        .value.filter((b) => b.fieldName == parent)[0].value = getField(
        l__data[0].value,
        id,
        data
      );
    } else {
      var l__data = selectedItem.data.filter((a) => a.fieldName == first)[0];
      selectedItem.data.filter((a) => a.fieldName == first).value = getField(
        l__data.value,
        id,
        data
      );
    }

    var separateTeensAdults = selectedItem.data
      .filter((a) => a.fieldName == "practiceProfile")[0]
      .value.filter((b) => b.fieldName == "separateTeensAdults")[0].value;

    var showHourly = selectedItem.data
      .filter((a) => a.fieldName == "practiceProfile")[0]
      .value.filter((b) => b.fieldName == "showHourly")[0].value;
    var separateRole = selectedItem.data
      .filter((a) => a.fieldName == "practiceProfile")[0]
      .value.filter((b) => b.fieldName == "separateRole")[0].value;

    toChangeDisplay(
      selectedItem,
      separateRole,
      separateTeensAdults,
      showHourly
    );
  };

  /*const save = (estimate) => {
    if (step > 2) {
      if (window.navigator.onLine) {
        toAddAssessment(selectedItem).then((res) => {
          var l__json = {
            id: res.id,
            results: selectedItem.data,
            status: estimate ? 1 : 0,
            inputs: selectedItem.inputs,
            indicators: selectedItem.indicators,
            userId: 1,
          };
          add(l__json).then(
            (event) => {
              navigate({
                pathname: "/results",
                state: { id: event },
              });
            },
            (error) => {
              console.log(error);
            }
          );
        });
      } else {
        add({
          id: -1,
          results: selectedItem.data,
          status: estimate ? 1 : 0,
          inputs: selectedItem.inputs,
          indicators: selectedItem.indicators,

          userId: 1,
        }).then(
          (event) => {
            navigate({
              pathname: "/results",
              state: { id: event },
            });
          },
          (error) => {
            console.log(error);
          }
        );
      }
    } else {
      setStep(step + 1);
    }
  };*/

  const handleClick = () => {
    toAddAssessment(selectedItem).then((res) => {
      var l__json = {
        id: res.id,
        results: selectedItem.data,
        templateId: selectedItem.key,
        status: 1,
        inputs: selectedItem.inputs,
        indicators: selectedItem.indicators,
        userId: 1,
      };
      add(l__json).then(
        (event) => {
          navigate("/results", { state: { id: event } });
        },
        (error) => {
          console.log(error);
          alert("error " + error);
        }
      );
    });
  };

  const validate = () => {
    var index = templates.findIndex((e) => e.key == selectedItem.key);
    elRefs[index].current.validate();
  };

  return (
    <div onClick={() => hidePopup()}>
      <HeaderUser step={step} updateStep={() => setStep(step - 1)} />
      {loading ? (
        <ScreenLoader />
      ) : (
        <>
          {templates.length > 0 ? (
            <>
              <div style={{ textAlign: "center", marginTop: "10vh" }}>
                <Typography.Title level={2} className="roi--title-admin">
                  <FormattedMessage id="fillTheform" />
                </Typography.Title>
              </div>

              <Tabs
                type="card"
                onChange={OnChange}
                hideAdd
                activeKey={activeKey}
              >
                {templates.map((pane, index) => (
                  <TabPane
                    className="roi--tab"
                    tab={pane.title}
                    key={pane.key}
                    closable={pane.closable}
                  >
                    <PracticeProfile
                      input={true}
                      toUpdateData={toUpdateDataPractice}
                      step={step}
                      setStep={setStep}
                      tool={true}
                      ref={elRefs[index]}
                      all={true}
                      data={selectedItem.data.filter(
                        (a) => a.fieldName == "practiceProfile"
                      )}
                    />
                    {step > 2 && (
                      <ManageTheDataUser
                        nb={nb}
                        separateTeensAdults={separateTeensAdults}
                        separateRole={separateRole}
                        showHourly={showHourly}
                        data={selectedItem}
                        toUpdateTheDefaultData={toUpdateTheDefaultData}
                      />
                    )}
                  </TabPane>
                ))}
              </Tabs>
              {step > 2 ? (
                <div style={{ textAlign: "center" }}>
                  <Button
                    className="roi--button-primary"
                    style={{
                      marginTop: "4vh",
                      textAlign: "center",
                      marginBottom: "2vh",
                    }}
                    disabled={emptyFields}
                    onClick={() => handleClick()}
                  >
                    <FormattedMessage id="estimate" />
                  </Button>

                  {/* <Button
                  className="roi--button-third"
                  style={{
                    marginTop: "4vh",
                    marginLeft: "10vh",
                    textAlign: "center",
                    marginBottom: "2vh",
                  }}
                  disabled={emptyFields}
                  onClick={() => save(false)}
                >
                  <FormattedMessage id="saveForLater" />
                </Button> */}
                </div>
              ) : (
                <div style={{ textAlign: "center" }}>
                  <Button
                    className="roi--button-primary"
                    style={{
                      marginTop: "4vh",
                      textAlign: "center",
                      marginBottom: "2vh",
                    }}
                    //onClick={() =>  setStep(step + 1)}
                    onClick={() => {
                      validate();
                    }}
                  >
                    <FormattedMessage id="next" />
                  </Button>
                </div>
              )}
            </>
          ) : (
            <div style={{ textAlign: "center", marginTop: "10vh" }}>
              <Typography.Title level={2} className="roi--title-admin">
                <FormattedMessage id="contactAdmin" />
              </Typography.Title>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default Tool;
